<template>
    <div class="component-data">
        <popup-camera v-bind:is-active="cameraPopup" v-on:closepopup="closeCameraPopup" v-model="cameraPhotosShore" :max-photos="cameraMaxPhotos"></popup-camera>
        <div class="docs-container">
            <div class="steps-bar" v-if="step<8">
                <span class="progress-step" @click="goToStep(1)" v-bind:class="step == 1 ? lastVisitedStep > 1 ? 'last-step': 'current-step' : 'filled-step'">1</span>
                <span class="progress-step" @click="goToStep(2)" v-bind:class="step == 2 ? lastVisitedStep > 2 ? 'last-step': 'current-step' : lastVisitedStep >= 2 ? lastVisitedStep == 2 ? 'last-filled-step' : 'filled-step': 'new-step'">2</span>
                <span class="progress-step" @click="goToStep(3)" v-bind:class="step == 3 ? lastVisitedStep > 3 ? 'last-step': 'current-step' : lastVisitedStep >= 3 ? lastVisitedStep == 3 ? 'last-filled-step' : 'filled-step': 'new-step'">3</span>
                <span class="progress-step" @click="goToStep(4)" v-bind:class="step == 4 ? lastVisitedStep > 4 ? 'last-step': 'current-step' : lastVisitedStep >= 4 ? lastVisitedStep == 4 ? 'last-filled-step' : 'filled-step': 'new-step'">4</span>
                <span class="progress-step" @click="goToStep(5)" v-bind:class="step == 5 ? lastVisitedStep > 5 ? 'last-step': 'current-step' : lastVisitedStep >= 5 ? lastVisitedStep == 5 ? 'last-filled-step' : 'filled-step': 'new-step'">5</span>
                <span class="progress-step" @click="goToStep(6)" v-bind:class="step == 6 ? lastVisitedStep > 6 ? 'last-step': 'current-step' : lastVisitedStep >= 6 ? lastVisitedStep == 6 ? 'last-filled-step' : 'filled-step': 'new-step'">6</span>
                <span class="progress-step" @click="goToStep(7)" v-bind:class="step == 7 ? lastVisitedStep > 7 ? 'last-step': 'current-step' : lastVisitedStep >= 7 ? lastVisitedStep == 7 ? 'last-filled-step' : 'filled-step': 'new-step'">7</span>
            </div>
            <div v-if="step == 1">
                <div class="form-field">
                    <p class="form-text">Введите номер полиса/договора</p>
                    <imasked-input v-model="polis" :key="'polis'" @change="checkPolis" :idname="'polis'" :invalid="polisInvalid" v-uppercase></imasked-input>
                    <p class="form-err-msg" v-if="polisNotFound">Договор не найден</p>
                </div>
                <div class="form-field">
                    <p class="form-text">Введите последние 7 символов VIN кода</p>
                    <imasked-input v-model="vin" :key="'vin'" @change="checkVin" :idname="'vin'" :invalid="vinInvalid" :addclass="polisClass" :mask="vinMask"></imasked-input>
                </div>

                <div class="form-field">
                    <p class="form-text">Введите дату события</p>
                    <input type="date" v-model="date" @change="checkDate" v-bind:class="dateInvalid ? 'invalid-input' : ''" class="form-input" id="date">
                </div>

                <div class="form-field">
                    <p class="form-text">Выберите тип страхового события</p>
                    <select class="select-input d-block w-100" v-model="type" @change="checkType" v-bind:class="typeInvalid ? 'invalid-input' : ''" id="type">
                            <option value=""></option>
                            <option value="1">ДТП</option>
                            <option value="2">Противоправные действия третьих лиц</option>
                        </select>
                </div>

                <p class="form-err-msg" v-if="formErrors">
                    Проверьте правильность заполнения полей формы. Поля с ошибками: {{errFields}}
                </p>
                <button type="button" class="btn" @click="nextStepOne">ДАЛЕЕ</button>
            </div>
            <div v-if="step==2">
                <div class="form-field">
                    <p class="form-text">ФИО заявителя полностью</p>
                    <input type="text" maxlength="50" v-model="drName" @change="checkDrName" v-bind:class="drNameInvalid ? 'invalid-input' : ''" class="form-input" id="drname">
                </div>
				<div class="form-field">
                    <p class="form-text">Серия и номер паспорта заявителя</p>
					<imasked-input v-model="drPassport" :key="'drPassport'" :idname="'drpassport'" @change="checkDrPassport" :invalid="drPassportInvalid" :mask="passportMask"></imasked-input>
                </div>
                <div class="form-field">
                    <p class="form-text">Мобильный телефон заявителя</p>
                    <imasked-input v-model="drPhone" :key="'drPhone'" :idname="'drphone'" @change="checkDrPhone" :invalid="drPhoneInvalid" :mask="phoneMask"></imasked-input>
                </div>
                <div class="form-field">
                    <p class="form-text">Электронная почта заявителя</p>
                    <input type="email" maxlength="40" v-model="drEmail" @change="checkDrEmail" v-bind:class="drEmailInvalid ? 'invalid-input' : ''" class="form-input" id="dremail">
                </div>
                <div class="form-field">
                    <input type="radio" id="driverok" name="driver-state" value="driverok" v-model="driverState">
                    <label for="driverok">Заявитель совпадает с водителем</label><br>
                    <input type="radio" id="driver_other" name="driver-state" value="driver_other" v-model="driverState">
                    <label for="driver_other">Водитель – иное лицо</label><br>
                    <input type="radio" id="no_driver" name="driver-state" value="no_driver" v-model="driverState">
                    <label for="no_driver">Во время события водитель отсутствовал</label><br>
                </div>
                <div class="form-field" v-if="driverState == 'driver_other'">
                    <p class="form-text">ФИО водителя</p>
                    <input type="text" v-model="otherDriverName" @change="checkOtherDrName" v-bind:class="otherDrNameInvalid ? 'invalid-input' : ''" class="form-input" id="odrname">
                </div>
                <p class="form-err-msg" v-if="formErrors">
                    Проверьте правильность заполнения полей формы. Поля с ошибками: {{errFields}}
                </p>
                <button type="button" class="btn main-button" @click="nextStepTwo">ДАЛЕЕ</button>
            </div>
            <div v-if="step==3">
                <div class="form-field">
                    <p class="form-text">Адрес места события</p>
                    <input type="text" v-model="place" placeholder="начните вводить улицу, работает автозаполнение"  @change="checkPlace" v-bind:class="placeInvalid ? 'invalid-input' : ''" class="form-input address" id="place">
                </div>
                <div class="form-field">
                    <p class="form-text">Обстоятельства происшествия</p>
                    <textarea maxlength="350" v-model="evtDescr" @change="checkEvtDescr" v-bind:class="evtDescrInvalid ? 'invalid-input' : ''" class="form-input textarea-input" id="evtdescr"></textarea>
                </div>
                <div class="form-field">
                    <p class="form-text">Повреждения автомобиля</p>
                    <textarea maxlength="200" v-model="carDescr" @change="checkCarDescr" v-bind:class="carDescrInvalid ? 'invalid-input' : ''" class="form-input textarea-input" id="cardescr"></textarea>
                </div>
                <div class="form-field">
                    <p class="form-text">Событие оформлено</p>
                    <select class="select-input d-block w-100" v-model="framed" @change="checkFramed" v-bind:class="framedInvalid ? 'invalid-input' : ''" id="framed">
                        <option value=""></option>
                        <option value="1" v-if="type==1">Европротокол</option>
                        <option value="2" v-if="type==1">ГИБДД</option>
                        <option value="3" v-if="type==2">ОВД</option>
                        <option value="4">Обращение без справок</option>
                    </select>
                </div>
				<div class="form-field">
                    <p class="form-text">Может ли ТС передвигаться своим ходом?</p>
                    <select class="select-input d-block w-100" v-model="carCanMove" @change="checkType" v-bind:class="typeInvalid ? 'invalid-input' : ''" id="type">
                            <option value=""></option>
                            <option value=true>Да</option>
                            <option value=false>Нет</option>
                        </select>
                </div>
				<div class="form-field" v-bind:class="carCanMove != 'false' ? 'hide-field' : ''">
                    <p class="form-text">Адрес осмотра ТС</p>
                    <input type="text" v-model="carViewPlace" placeholder="начните вводить улицу, работает автозаполнение" @change="checkPlace" v-bind:class="placeInvalid ? 'invalid-input' : ''" class="form-input address" id="car-view-place">
                </div>
                <p class="form-err-msg" v-if="formErrors">
                    Проверьте правильность заполнения полей формы. Поля с ошибками: {{errFields}}
                </p>
                <button type="button" class="btn main-button" @click="nextStepThree">ДАЛЕЕ</button>
            </div>
            <div v-if="step==4">
                <div class="form-field form-field-photos">
                    <p class="form-text">8 фото автомобиля со всех сторон и углов</p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in selectedCarPhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmPreview(1, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper" v-if="showButtons_selectedCarPhotos">
                        <div class="photo-button photo-button-left" @click="openCamera('selectedCarPhotos', 8)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-car-photos" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-car-photos" @change="onPhotoCarAdd" type="file" accept="image/*" multiple />
                    </div>


                    <p class="form-err-msg" v-if="carPhotosLimErr">
                        {{carPhotosLimErr}}
                    </p>
                </div>
                <div class="form-field form-field-photos">
                    <p class="form-text">4 фото повреждений</p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in selectedDamagePhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmPreview(2, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper" v-if="showButtons_selectedDamagePhotos">
                        <div class="photo-button photo-button-left" @click="openCamera('selectedDamagePhotos', 4)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-damages" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-damages" @change="onPhotoDamageAdd" type="file" accept="image/*" multiple />
                    </div>


                    <p class="form-err-msg" v-if="damagePhotosLimErr">
                        {{damagePhotosLimErr}}
                    </p>
                </div>
                <div class="form-field form-field-photos">
                    <p class="form-text">VIN код на лобовом стекле</p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-if="vinPhoto">
                            <img :src="vinPhoto" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmPreview(3, 0)">
                        </div>
                    </div>
 
                    <div class="file-input-wrapper" v-if="showButtons_vinPhoto">
                        <div class="photo-button photo-button-left" @click="openCamera('vinPhoto', 1)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-vin" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-vin" @change="onPhotoVin" type="file" accept="image/*"/>
                    </div>
                </div>
                <div class="form-field form-field-photos">
                    <p class="form-text">Приборная панель заведенного ТС</p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-if="panelPhoto">
                            <img :src="panelPhoto" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmPreview(4, 0)">
                        </div>
                    </div>

                    <div class="file-input-wrapper" v-if="showButtons_panelPhoto">
                        <div class="photo-button photo-button-left" @click="openCamera('panelPhoto', 1)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-panel" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-panel" @change="onPhotoPanel" type="file" accept="image/*"/>
                    </div>

                </div>
                <p class="form-err-msg" v-if="formErrors">
                    Проверьте правильность заполнения полей формы. Поля с ошибками: {{errFields}}
                </p>
                <button type="button" class="btn main-button" @click="nextStepFour">ДАЛЕЕ</button>
            </div>
            <div v-if="step==5">
                <div class="form-field form-field-photos">
                    <p class="form-text">СТС с 2-х сторон</p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in stsPhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmS5Preview(1, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper" v-if="showButtons_stsPhotos">
                        <div class="photo-button photo-button-left" @click="openCamera('stsPhotos', 2)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-sts" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-sts" @change="onStsPhotosAdd" type="file" accept="image/*" multiple />
                    </div>


                    <p class="form-err-msg" v-if="stsPhotoLimErr">
                        {{stsPhotoLimErr}}
                    </p>
                </div>
                <div class="form-field form-field-photos" v-if="!moveState">
                   <p class="form-text">Водительское удостоверение с 2-х сторон</p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in driverLicPhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmS5Preview(2, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper" v-if="showButtons_driverLicPhotos">
                        <div class="photo-button photo-button-left" @click="openCamera('driverLicPhotos', 2)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-driverlic" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                           <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-driverlic" @change="onDriverLicAdd" type="file" accept="image/*" multiple />
                    </div>


                    <p class="form-err-msg" v-if="driverLicPhotosLimErr">
                        {{driverLicPhotosLimErr}}
                    </p>
                </div>
                <div class="form-field form-field-photos" v-if="type != 2 && framed != '4'">
                    <p class="form-text">Извещение о ДТП с 2-х сторон <span v-if="framed != '1'">(если оформлялось)</span></p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in dtpNotifPhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmS5Preview(3, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper" v-if="showButtons_dtpNotifPhotos">
                        <div class="photo-button photo-button-left" @click="openCamera('dtpNotifPhotos', 2)" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-notif" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-notif" @change="onDtpNotifAdd" type="file" accept="image/*" multiple />
                    </div>
                    <p class="form-err-msg" v-if="dtpNotifPhotosLimErr">
                        {{dtpNotifPhotosLimErr}}
                    </p>
                </div>
                <div class="form-field form-field-photos" v-if="framed != '4' && framed != '1' ">
                    <p class="form-text">Все документы из компетентных органов с 2-х сторон <span v-if="framed != '2'">(если оформлялись)</span></p>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in govDocsPhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmS5Preview(4, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper">
                        <div class="photo-button photo-button-left" @click="openCamera('govDocsPhotos')" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-govdoc" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-govdoc" @change="onGovDocsPhotosAdd" type="file" accept="image/*" multiple />
                    </div>

                </div>
                <div class="form-field form-field-photos">
                    <p class="form-text">Прочие документы (при наличии):</p>
					<ul>
						<li>Доверенность заявителя</li>
						<li>Доверенность на управление ТС</li>
						<li>Договор аренды/лизинга</li>
					</ul>
                    <div class="preview-container">
                        <div class="photos-preview-container" v-for="photo, n in driverLetterPhotos">
                            <img :src="photo" photo class="photo-preview"  />
                            <img src="/images/remove.svg" class="photo-preview-remove" @click="rmS5Preview(5, n)">
                        </div>
                    </div>

                    <div class="file-input-wrapper">
                        <div class="photo-button photo-button-left" @click="openCamera('driverLetterPhotos')" v-if="mobileBrowser && cameraAvailable">
                            <img src="/images/camera.png">
                            <p>Сделать на камеру</p>
                        </div>
                         <label for="file-upload-letter" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="!mobileBrowser || cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать/выбрать фото</p>
                        </label>
                        <input id="file-upload-letter" @change="onDriverLetterPhotosAdd" type="file" accept="image/*" multiple />
                    </div>


                </div>
                <p class="form-err-msg" v-if="formErrors">
                    Проверьте правильность заполнения полей формы. Поля с ошибками: {{errFields}}
                </p>
                <button type="button" class="btn main-button" @click="nextStepFive">ДАЛЕЕ</button>
            </div>
            <div v-if="step==6">
                <div class="form-field">
                    <p class="form-text">Укажите на какой ремонтной станции вы хотели бы произвести ремонт или оставьте поле пустым</p>
                    <textarea maxlength="50" v-model="repareWishes" class="form-input textarea-input" id="repareWishes"></textarea>
                </div>
                <button type="button" class="btn main-button" @click="nextStepSix">ДАЛЕЕ</button>
            </div>
            <div v-if="step==7">
                <div class="form-field">
                    <p class="form-text">Поставьте (нарисуйте) свою подпись в поле для отправки заявления</p>
                    <subscr-canvas v-model="subscrVal"></subscr-canvas>
                </div>
                <button type="button" class="btn main-button last-steps-btns" @click="finNewCase">Завершить регистрацию</button>
            </div>
            <div v-if="step==8">
                <div class="form-field">
                    <load-spinner></load-spinner>
                </div>
                <div v-if="uploadedPhotosCount != allPhotosCount" class="form-field">
                    <p class="status-description ">Ожидайте, страховое событие в стадии оформления. Это может занять от 1 до 15 минут. Вы можете покинуть страницу, статус оформления будет направлен вам на электронную почту.</p>
                </div>
				<div v-else>
					<p class="status-description ">Ожидайте, страховое событие в стадии оформления. Это может занять от 1 до 15 минут. Вы можете покинуть страницу, статус оформления будет направлен вам на электронную почту.</p>
				</div>
            </div>
            <div v-if="step==9">
                <div v-if="eventNum">
                    <div class="form-field">
                        <img class="finish-state" src="/images/done.png">
                    </div>
                    <div class="form-field">
                        <p class="status-description" style="padding: 0px 15px">Ваше страховое событие успешно зарегистрировано под номером {{eventNum}}. Рекомендуем сохранить этот номер. Ожидайте, с Вами свяжется представитель страховой компании. Статус страхового события можно узнать по телефону 
                            <span class="request-fin-phone">+7 (800) 333-09-99.</span></p>
                    </div>
                </div>
                <div v-if="!eventNum">
                     <div class="form-field">
                        <img class="finish-state" src="/images/alert.svg">
                     </div>
                     <div class="form-field">
                        <h3>Что-то не так</h3>
                     </div>
                     <div class="form-field">
                        <p class="status-description ">При регистрации возникла ошибка. Попробуйте снова. {{errLog}}</p>
                     </div>
                        <!-- <button type="button" class="btn main-button last-steps-btns" @click="finNewCase" v-if="showRetBtn">Повторить отправку</button> -->
                </div>
                <button type="button" class="btn main-button last-steps-btns" @click="goToMain">Вернуться на главный экран</button>
            </div>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios'
import ImaskedInput from './ImaskInput.vue'
import SubscriptionCanvas from './SubscriptionCanvas.vue'
import LoadSpinner from "./LoadSpinner.vue"
import CameraPopup from './CameraPopup.vue'


export default {
  name: 'new-request',
  components: {
        'imasked-input': ImaskedInput,
        'subscr-canvas': SubscriptionCanvas,
        'load-spinner': LoadSpinner,
        'popup-camera': CameraPopup,
    },
	props: ['isActive', 'cameraAvailable'],
    data() {
		return { 
			mobileBrowser: true,
			showCancel: false, //for popup
			cameraPopup: false,
			step: 1,
			lastVisitedStep: 1,
			addressPlugin: undefined,
			//Step1 fields
			polisMask: "*****/***/*****/**",
			polisClass: "polis-input",
			polis: "",
			polisCleaned: "",
            polisInvalid: false,
            polisNotFound: false,
			vin: "",
			vinMask: "* * * * * * *",
			vinInvalid: false,
			date: "",
			dateInvalid: false,
			type: "", //Default value
			typeInvalid: false,
			formErrors: false,
			errFields: "",
			doLiveCheck: false,
			//Step2 fields
			drName: "",
			drNameInvalid: false,
			drPassport: "",
			drPassportInvalid: false,
			passportMask: "0000 000000",
			drPhone: "",
			phoneMask: "+{7}(000)000-00-00",
			drPhoneInvalid: false,
			drEmail: "",
            drEmailInvalid: false,
            driverState: "driverok",
            otherDriverName: "",
            moveState: false,
            otherDrNameInvalid: false,
			//Step3 fields
			place: "",
			kladrId: "",
			kladrIdViewPlace: "",
			placeInvalid: false,
			evtDescr: "",
			evtDescrInvalid: false,
			carDescr: "",
			carDescrInvalid: false,
			framed: "",
			framedInvalid: false,
			carCanMove: "",
			carCanMoveInvalid: false,
			carViewPlace: "",
			carViewPlaceInvalid: false,
			cameraPhotosShore: [],
			cameraPhotosTargetName: "",
			cameraMaxPhotos: 0,
			selectedCarPhotos: [],
			selectedCarPhotosFiles: [],
			carPhotosInvalid: false,
			carPhotosLimErr: "",
			selectedDamagePhotos: [],
			selectedDamagePhotosFiles: [],
			damagePhotosInvalid: false,
			damagePhotosLimErr: "",
			vinPhoto: '',
			vinPhotoFile: '',
			panelPhoto: '',
			panelPhotoFile: '',
			stsPhotos: [],
			stsPhotosFiles: [],
			stsPhotoLimErr: "",
			driverLicPhotos: [],
			driverLicPhotosFiles: [],
			driverLicPhotosLimErr: "",
			dtpNotifPhotos: [],
            dtpNotifPhotosFiles: [],
            dtpNotifPhotosLimErr: "",
			govDocsPhotos: [],
			govDocsPhotosFiles: [],
			driverLetterPhotos: [],
            driverLetterPhotosFiles: [],
            showButtons_selectedCarPhotos: true,
            showButtons_selectedDamagePhotos: true,
            showButtons_vinPhoto: true,
            showButtons_panelPhoto: true,
            showButtons_stsPhotos: true,
            showButtons_driverLicPhotos: true,
            showButtons_dtpNotifPhotos:true,
			repareWishes: "",
			allPhotosCount: 1, //For correct view of state that not all photos uploaded (before start upload)
			uploadedPhotosCount: 0,
			photosUploadError: false,
			carPhotosUploaded: false,
			carPhotosUploadedp1: false,
			carPhotosUploadedp2: false,
			damagePhotoUploaded: false,
			vinPhotoUploaded: false,
			panelPhotoUploaded: false,
			stsPhotoUploaded: false,
			driverLicPhotoUploaded: false,
			dtpNotifPhotoUploaded: false,
			govDocPhotoUploaded: false,
			driverLetterPhotoUploaded: false,
			subscrVal: '',
			//Upload errors
			vinPanelUploadError: false,
			carPhotosUploadError: false,
			damagePhotoUploadError: false,
			stsPhotoUploadError: false,
			driverLicPhotoUploadError: false,
			dtpNotifPhotoUploadError: false,
			govDocPhotoUploadError: false,
			driverLetterPhotoUploadError: false,
			requestId: "",
			eventNum: "",
			errLog: "",
			getStatusRetrs: 0,
			showRetBtn: true,
		 }
    },
    mounted() {
        let vm = this
        let body = document.getElementById("appbody");
        body.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                vm.enterClicked()
            }
		});
		this.mobileBrowser = this.inMobileBrowser()
    },
	watch: {
		step: function(newVal, oldVal) {
			window.scrollTo(0,0);
			
			if (this.lastVisitedStep < newVal) {
				this.lastVisitedStep = newVal
			}
		},
		isActive: function(){
			this.clean()
        },
        driverState: function() {
            if (this.driverState == "driver_other") {
                window.scrollTo(0,document.body.scrollHeight);
            }
        }
	},
    methods: {

		inMobileBrowser() {
			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		},
        
        enterClicked() {
            switch (this.step) {
                case 1:
                    this.nextStepOne()
                    break
                case 2:
                    this.nextStepTwo()
                    break
                case 3:
                    this.nextStepThree()
                    break
                case 4:
                    this.nextStepFour()
                    break
                case 5:
                    this.nextStepFive()
                    break
                case 6:
                    this.nextStepSix()
                    break
                case 7:
                    this.finNewCase()
                    break
            }
        },
		closeCameraPopup() {
			this.cameraPopup = false
            
            if (this.cameraPhotosTargetName == "vinPhoto") {
                console.log(this.cameraPhotosTargetName)
                this.vinPhoto = this.cameraPhotosShore[0]
                if (this.vinPhoto == undefined) {
                    this.vinPhoto = ''
                } else {
                    this.vinPhoto = this.cameraPhotosShore
                }
                if (this.vinPhoto == '') {
                    this.showButtons_vinPhoto = true
                } else {
                    this.showButtons_vinPhoto = false
                }
                
            } else if (this.cameraPhotosTargetName == "panelPhoto") {
                this.panelPhoto = this.cameraPhotosShore[0]
                if (this.panelPhoto == undefined) {
                    this.panelPhoto = ''
                } else {
                    this.panelPhoto = this.cameraPhotosShore
                }
                if (this.panelPhoto == '') {
                    this.showButtons_panelPhoto = true
                } else {
                    this.showButtons_panelPhoto = false
                }
            } else {
                this[this.cameraPhotosTargetName] = this.cameraPhotosShore
                this.controlPhotosBtns(this.cameraPhotosTargetName, this.cameraMaxPhotos)
            }
            
		},
		openCamera(targetStore, maxPhotos){
			this.cameraPhotosTargetName = targetStore
			this.cameraPhotosShore = this[targetStore]
			this.cameraMaxPhotos = maxPhotos
			this.cameraPopup = true
		},
		goToStep(stepNum) {
            if (stepNum <= this.lastVisitedStep) {
                this.step = stepNum
                this.formErrors = false
            }
        },
		closePopup() {
			this.showCancel = false
		},
		checkPolis(evt) {
			if (!this.doLiveCheck) {
				return
            }
			this.polisNotFound = false
			let polisCleaned = this.polis.replace(/_/g, '').replaceAll('/', '')
			let alphaCharsOnly = alphanumeric(polisCleaned)
			if (!alphaCharsOnly) {
				this.polisInvalid = true
				this.formErrors = true
				this.doStepOneErrMsg()
				return
			}
			console.log(polisCleaned.length)
			if ((polisCleaned.length != 15) && (polisCleaned.length != 14) && (polisCleaned.length != 17)) {
				this.polisInvalid = true
				this.formErrors = true
				this.doStepOneErrMsg()
			} else {
				this.polisCleaned = polisCleaned
				if (this.polis.length > 20) {
					this.polisCleaned = polisCleaned
					polisCleaned = this.polis.length.substr(0,20)
					this.polis = polisCleaned
                }
                if (this.polis.startsWith("0323") || this.polis.startsWith("0325") || this.polis.startsWith("0327")) {
                    this.polisInvalid = false
                    this.doStepOneErrMsg()
                } else {
                    this.polisNotFound = true
                    this.polisInvalid = true
                    this.formErrors = true
				    this.doStepOneErrMsg()
                }
				
			}
		},
		checkVin() {
			if (!this.doLiveCheck) {
				return
			}
			let vinCleaned = this.vin.replace(/_/g, '').replace(/ /g, '')
			let alphaCharsOnly = alphanumeric(vinCleaned)
			if (!alphaCharsOnly) {
				this.vinInvalid = true
				this.formErrors = true
				this.doStepOneErrMsg()
				return
			}
			
			if (vinCleaned.length > 7) {
				vinCleaned = vinCleaned.substr(0,7)
			}
			this.vin = vinCleaned

			if (this.vin.length != 7) {
				this.vinInvalid = true
				this.formErrors = true
				this.doStepOneErrMsg()
			} else {
				this.vinInvalid = false
				this.doStepOneErrMsg()
			}
		},
		checkDate() {
			if (!this.doLiveCheck) {
				return
			}
			if (this.date == "") {
				this.dateInvalid = true
				this.formErrors = true
				this.doStepOneErrMsg()
			} else {
				this.dateInvalid = false
				this.doStepOneErrMsg()
			}
		},
		checkType() {
			if (!this.doLiveCheck) {
				return
			}
			if (!this.type) {
				this.typeInvalid = true
				this.formErrors = true
				this.doStepOneErrMsg()
			} else {
				this.typeInvalid = false
				this.doStepOneErrMsg()
			}
		},
		checkDrName() {
            if (!this.doLiveCheck) {
				return
			}
			this.drName = this.drName.trim()
			if (this.drName.length < 4) {
				this.drNameInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
				return
			}
			let nameParts = this.drName.split(' ')
			if (nameParts.length != 3) {
				this.drNameInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
				return
			}
			this.drNameInvalid = false
			this.doStepTwoErrMsg()
			
        },
		checkDrPassport() {
			if (!this.doLiveCheck) {
				return
			}
			let drPassportCleaned = this.drPassport.replace(/_/g, '').replace(/ /g, '')

			let alphaCharsOnly = alphanumeric(drPassportCleaned)
			if (!alphaCharsOnly) {
				this.drPassportInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
				return
			}

			if (drPassportCleaned.length < 10) {
				this.drPassportInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
				return
			}
			
			if (drPassportCleaned.length > 10) {
				drPassportCleaned = drPassportCleaned.substr(0,10)
			}
			this.drPassport = drPassportCleaned
			this.drPassportInvalid = false
			this.doStepTwoErrMsg()
		},
        checkOtherDrName() {
			if (!this.doLiveCheck) {
				return
			}
			if (this.otherDriverName.length < 4) {
				this.otherDrNameInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
			} else {
				this.otherDrNameInvalid = false
				this.doStepTwoErrMsg()
			}
		},
		checkDrPhone() {
			if (!this.doLiveCheck) {
				return
			}
			let phoneCleaned = this.drPhone.replace(/_/g, '')
			if (phoneCleaned.length < 16) {
				this.drPhoneInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
			} else {
				if (phoneCleaned.length > 16) {
					phoneCleaned = phoneCleaned.substr(0,16)
				}
				this.drPhone = phoneCleaned
				this.drPhoneInvalid = false
				this.doStepTwoErrMsg()
			}
		},
		checkDrEmail() {
			if (!this.doLiveCheck) {
				return
			}
			if (!validateEmail(this.drEmail)) {
				this.drEmailInvalid = true
				this.formErrors = true
				this.doStepTwoErrMsg()
			} else {
				this.drEmailInvalid = false
				this.doStepTwoErrMsg()
			}
		},
		checkPlace() {
			if (!this.doLiveCheck) {
				return
			}
			if (this.place.length < 4) {
				this.placeInvalid = true
				this.doStepThreeErrMsg()
			} else {
				this.placeInvalid = false
				this.doStepThreeErrMsg()
			}
		},
		checkCarCanMove() {
			if (!this.doLiveCheck) {
				return
			}
			console.log(this.carCanMove)
			if (this.carCanMove == "") {
				this.carCanMoveInvalid = true
				this.doStepThreeErrMsg()
			} else {
				this.carCanMoveInvalid = false
				this.doStepThreeErrMsg()
			}
		},

		checkViewPlace() {
			if (!this.doLiveCheck) {
				return
			}
			if (this.carCanMove == "false"){
				if (this.carViewPlace.length < 4) {
					this.carViewPlaceInvalid = true
					this.doStepThreeErrMsg()
				} else {
					this.carViewPlaceInvalid = false
					this.doStepThreeErrMsg()
				}
			} else {
				this.carViewPlaceInvalid = false
				this.doStepThreeErrMsg()
			}
			
		},

		checkEvtDescr() {
            if (!this.doLiveCheck) {
				return
			}
            this.evtDescrInvalid = false
            this.doStepThreeErrMsg()
			
			// if (this.evtDescr.length < 5) {
			// 	this.evtDescrInvalid = true
			// 	this.doStepThreeErrMsg()
			// } else {
			// 	this.evtDescrInvalid = false
			// 	this.doStepThreeErrMsg()
			// }
		},
		checkCarDescr() {
			if (!this.doLiveCheck) {
				return
            }
            this.carDescrInvalid = false
				this.doStepThreeErrMsg()
			// if (this.carDescr.length < 4) {
			// 	this.carDescrInvalid = true
			// 	this.doStepThreeErrMsg()
			// } else {
			// 	this.carDescrInvalid = false
			// 	this.doStepThreeErrMsg()
			// }
		},
		checkFramed() {
			if (!this.doLiveCheck) {
				return
			}
			if (!this.framed) {
				this.framedInvalid = true
				this.doStepThreeErrMsg()
			} else {
				this.framedInvalid = false
				this.doStepThreeErrMsg()
			}
		},
		onPhotoCarAdd(e){
			var files = e.target.files;
			if(files){
				let photosToAdd = []
				let totalLen = this.selectedCarPhotos.length + files.length
				if (totalLen > 8) {
					let canLeave = 8 - this.selectedCarPhotos.length
					for (let i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
					this.carPhotosLimErr = "Превышено максимальное количество фотографий, сначала удалите фотографии из добавленных. Добавлено фото: " + String(canLeave)
				} else {
					this.carPhotosLimErr = ""	
					photosToAdd = files
				}
				for (let i=0; i<photosToAdd.length; i++){
					let file = photosToAdd[i]
					this.selectedCarPhotosFiles.push(file)
				}
                this.addPhotos(photosToAdd, this.selectedCarPhotos, this.checkCarPhotos)
                this.controlPhotosBtns('selectedCarPhotos', 8)
			}
		},
		onPhotoDamageAdd(e){
			var files = e.target.files;
			if(files){
				let photosToAdd = []
				let totalLen = this.selectedDamagePhotos.length + files.length
				if (totalLen > 4) {
					let canLeave = 4 - this.selectedDamagePhotos.length
					for (let i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
					this.damagePhotosLimErr = "Превышено максимальное количество фотографий, сначала удалите фотографии из добавленных. Добавлено фото: " + String(canLeave)
				} else {
					this.damagePhotosLimErr = ""
					photosToAdd = files
				}
				for (let i=0; i<photosToAdd.length; i++){
					let file = photosToAdd[i]
					this.selectedDamagePhotosFiles.push(file)
				}
                this.addPhotos(photosToAdd, this.selectedDamagePhotos, this.checkDamagePhotos)
                this.controlPhotosBtns('selectedDamagePhotos', 4)
			}
		},
		onPhotoVin(e) {
			let vm = this
			var files = e.target.files;
			if (files) {
				var reader = new FileReader();
				reader.onload = function(e){
					vm.vinPhoto = e.target.result
					vm.checkVimPhoto()
				}
				reader.readAsDataURL(files[0]);
                this.vinPhotoFile = files[0]
                vm.showButtons_vinPhoto = false
			}
			
		},
		onPhotoPanel(e) {
			let vm = this
			var files = e.target.files;
			if (files) {
				var reader = new FileReader();
				reader.onload = function(e){
					vm.panelPhoto = e.target.result
					vm.checkPanelPhoto()
				}
				reader.readAsDataURL(files[0]);
                this.panelPhotoFile = files[0]
                vm.showButtons_panelPhoto = false
			}
			
		},
		onStsPhotosAdd(e) {
			var files = e.target.files;
			if(files){
				let photosToAdd = []
				let totalLen = this.stsPhotos.length + files.length
				if (totalLen > 2) {
					let canLeave = 2 - this.stsPhotos.length
					for (let i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
					this.stsPhotoLimErr = "Превышено максимальное количество фотографий, сначала удалите фотографии из добавленных. Добавлено фото: " + String(canLeave)
				} else {
					this.stsPhotoLimErr = ""
					photosToAdd = files
				}
				for (let i=0; i<photosToAdd.length; i++){
					let file = photosToAdd[i]
					this.stsPhotosFiles.push(file)
				}
                this.addPhotos(photosToAdd, this.stsPhotos, this.checkStsPhotos)
                this.controlPhotosBtns('stsPhotos', 2)
			}
		},
		onDriverLicAdd(e) {
			var files = e.target.files;
			if(files){
				let photosToAdd = []
				let totalLen = this.driverLicPhotos.length + files.length
				if (totalLen > 2) {
					let canLeave = 2 - this.driverLicPhotos.length
					for (let i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
					this.driverLicPhotosLimErr = "Превышено максимальное количество фотографий, сначала удалите фотографии из добавленных. Добавлено фото: " + String(canLeave)
				} else {
					this.driverLicPhotosLimErr = ""
					photosToAdd = files
				}
				for (let i=0; i<photosToAdd.length; i++){
					let file = photosToAdd[i]
					this.driverLicPhotosFiles.push(file)
				}
                this.addPhotos(photosToAdd, this.driverLicPhotos, this.checkDriverLicPhotos)
                this.controlPhotosBtns('driverLicPhotos', 2)
			}
		},
		onDtpNotifAdd(e) {
            
            var files = e.target.files;
			if(files){
				let photosToAdd = []
				let totalLen = this.dtpNotifPhotos.length + files.length
				if (totalLen > 2) {
					let canLeave = 2 - this.dtpNotifPhotos.length
					for (let i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
					this.dtpNotifPhotosLimErr = "Превышено максимальное количество фотографий, сначала удалите фотографии из добавленных. Добавлено фото: " + String(canLeave)
				} else {
					this.dtpNotifPhotosLimErr = ""
					photosToAdd = files
				}
				for (let i=0; i<photosToAdd.length; i++){
					let file = photosToAdd[i]
					this.dtpNotifPhotosFiles.push(file)
				}
                this.addPhotos(photosToAdd, this.dtpNotifPhotos, this.checkdtpNotifPhotos)
                this.controlPhotosBtns('dtpNotifPhotos', 2)
            }

		},
		onGovDocsPhotosAdd(e) {
			var files = e.target.files;
			if(files){
				for (let i=0; i<files.length; i++){
					let file = files[i]
					this.govDocsPhotosFiles.push(file)
				}
				this.addPhotos(files, this.govDocsPhotos)
			}
		},
		onDriverLetterPhotosAdd(e) {
			var files = e.target.files;
			if(files){
				for (let i=0; i<files.length; i++){
					let file = files[i]
					this.driverLetterPhotosFiles.push(file)
				}
                this.addPhotos(files, this.driverLetterPhotos)
			}
		},
		addPhotos(files, targetStore, checkCb) {
			var files_count = files.length;
			for (let i=0; i<files_count; i++){
				var reader = new FileReader();
				reader.onload = function(e){
					function resized(imageURL) {
						targetStore.push(imageURL)
						if (checkCb) {
							checkCb()
						}
					}
					resizeImage(e.target.result, resized)
					
				}
				reader.readAsDataURL(files[i]);
			}
        },
        controlPhotosBtns(targetStoreName, maxPhotos) {
            if (maxPhotos == undefined) {
                return
            }
            let store = this[targetStoreName]
            // console.log(targetStoreName, maxPhotos, store.length)
            if (store.length >= maxPhotos) {
                this["showButtons_"+targetStoreName] = false
            } else {
                this["showButtons_"+targetStoreName] = true
            }
        },
		rmPreview(type, num) {
			switch (type) {
				case 1:
					this.selectedCarPhotos.splice(num, 1)
					this.selectedCarPhotosFiles.splice(num, 1)
                    this.carPhotosLimErr = ""
                    this.controlPhotosBtns('selectedCarPhotos', 8)
					break
				case 2:
					this.selectedDamagePhotos.splice(num, 1)
					this.selectedDamagePhotosFiles.splice(num, 1)
                    this.damagePhotosLimErr = ""
                    this.controlPhotosBtns('selectedDamagePhotos', 8)
					break
				case 3:
					this.vinPhoto = ''
                    this.vinPhotoFile = ''
                    this.showButtons_vinPhoto = true
					break
				case 4:
					this.panelPhoto = ''
                    this.panelPhotoFile = ''
                    this.showButtons_panelPhoto = true
					break
			}
		},
		rmS5Preview(type, num) {
			switch (type) {
				case 1:
					this.stsPhotos.splice(num, 1)
					this.stsPhotosFiles.splice(num, 1)
                    this.stsPhotoLimErr = ""
                    this.controlPhotosBtns('stsPhotos', 2)
					break
				case 2:
					this.driverLicPhotos.splice(num, 1)
					this.driverLicPhotosFiles.splice(num, 1)
                    this.driverLicPhotosLimErr = ""
                    this.controlPhotosBtns('driverLicPhotos', 2)
					break
				case 3:
					this.dtpNotifPhotos.splice(num, 1)
                    this.dtpNotifPhotosFiles.splice(num, 1)
                    this.dtpNotifPhotosLimErr = ""
                    this.controlPhotosBtns('dtpNotifPhotos', 2)
					break
				case 4:
					this.govDocsPhotos.splice(num, 1)
					this.govDocsPhotosFiles.splice(num, 1)
					break
				case 5:
					this.driverLetterPhotos.splice(num, 1)
					this.driverLetterPhotosFiles.splice(num, 1)
					break
			}
		},
		checkCarPhotos() {
            this.controlPhotosBtns('selectedCarPhotos', 8)
			if (!this.doLiveCheck) {
				return
			}
			if (this.selectedCarPhotos.length < 8) {
				this.carPhotosInvalid = true,
				this.doStepFourErrMsg()
			} else {
				this.carPhotosInvalid = false,
				this.doStepFourErrMsg()
			}
		},
		checkDamagePhotos(){
            this.controlPhotosBtns('selectedDamagePhotos', 4)
			if (!this.doLiveCheck) {
				return
			}
			if (this.selectedDamagePhotos.length < 4) {
				this.damagePhotosInvalid = true,
				this.doStepFourErrMsg()
			} else {
				this.damagePhotosInvalid = false,
				this.doStepFourErrMsg()
			}
		},
		checkVimPhoto(){
			if (!this.doLiveCheck) {
				return
			}
			this.doStepFourErrMsg()
		},
		checkPanelPhoto(){
			if (!this.doLiveCheck) {
				return
			}
			this.doStepFourErrMsg()
		},
		checkStsPhotos() {
            this.controlPhotosBtns('stsPhotos', 2)
			if (!this.doLiveCheck) {
				return
			}
			this.doStepFiveErrMsg()
		},
		checkDriverLicPhotos() {
            this.controlPhotosBtns('driverLicPhotos', 2)
			if (!this.doLiveCheck) {
				return
			}
			this.doStepFiveErrMsg()
        },
        checkdtpNotifPhotos() {
            this.controlPhotosBtns('dtpNotifPhotos', 2)
			if (!this.doLiveCheck) {
				return
			}
			this.doStepFiveErrMsg()
        },
		doStepOneErrMsg() {
			this.errFields = ""
			if (this.polisInvalid) {
				this.errFields += "номер полиса, "
			}
			if (this.vinInvalid) {
				this.errFields += "VIN, "
			}
			if (this.dateInvalid){
				this.errFields += "дата, "
			}
			if (this.typeInvalid) {
				this.errFields += "вид события, "
			}
			if (this.errFields.length == 0) {
				this.formErrors = false
			} else {
				this.errFields = this.errFields.slice(0, -2);
				this.formErrors = true
            }
            window.scrollTo(0,document.body.scrollHeight);
			
		},
		doStepTwoErrMsg() {
			this.errFields = ""
			if (this.drNameInvalid) {
				this.errFields += "ФИО заявителя полностью, "
			}
			if (this.drPassportInvalid) {
				this.errFields += "серия и номер паспорта заявителя, "
			}
			if (this.drPhoneInvalid) {
				this.errFields += "номер телефона, "
			}
			if (this.drEmailInvalid){
				this.errFields += "электронная почта, "
            }
            if (this.otherDrNameInvalid){
				this.errFields += "ФИО водителя, "
			}
			if (this.errFields.length == 0) {
				this.formErrors = false
			} else {
				this.errFields = this.errFields.slice(0, -2);
				this.formErrors = true
            }
            window.scrollTo(0,document.body.scrollHeight);
			
		},
		doStepThreeErrMsg() {
			this.errFields = ""
			if (this.placeInvalid) {
				this.errFields += "адрес места события, "
			}
			if (this.evtDescrInvalid) {
				this.errFields += "обстоятельства проишествия, "
			}
			if (this.carDescrInvalid){
				this.errFields += "описание повреждений, "
			}
			if (this.framedInvalid){
				this.errFields += "оформление события, "
			}
			if (this.carCanMoveInvalid){
				this.errFields += "может ли авто передвигаться своим ходом, "
			}
			if (this.carViewPlaceInvalid){
				this.errFields += "место осмотра ТС, "
			}
			if (this.errFields.length == 0) {
				this.formErrors = false
			} else {
				this.formErrors = true
				this.errFields = this.errFields.slice(0, -2);
            }
            window.scrollTo(0,document.body.scrollHeight);
			
		},
		doStepFourErrMsg() {
			this.errFields = ""
			if (this.carPhotosInvalid) {
				this.errFields += "фотографии авто, "
			}
			if (this.damagePhotosInvalid) {
				this.errFields += "фотографии повреждений, "
			}
			if (!this.vinPhoto){
				this.errFields += "фотография VIN автомобиля, "
			}
			if (!this.panelPhoto) {
				this.errFields += "фотография приборной панели, "
			}
			if (this.errFields.length == 0) {
				this.formErrors = false
			} else {
				this.errFields = this.errFields.slice(0, -2);
				this.formErrors = true
            }
            window.scrollTo(0,document.body.scrollHeight);
		},
		doStepFiveErrMsg() {
			this.errFields = ""
			if(this.stsPhotos.length < 2) {
				this.errFields += "фотографии СТС, "
            }
            if (!this.moveState) {
                if(this.driverLicPhotos.length < 2) {
                    this.errFields += "фотографии водительского удостоверения, "
                }
            }
			if ((this.dtpNotifPhotos.length < 1) && (this.framed == 1)) {
				this.errFields += "извещение о ДТП, "
			}
			if ((this.govDocsPhotos.length < 1) && (this.framed == 2)) {
				this.errFields += "документы из компетентных органов, "
			}
			if (this.errFields.length == 0) {
				this.formErrors = false
			} else {
				this.errFields = this.errFields.slice(0, -2);
				this.formErrors = true
            }
            window.scrollTo(0,document.body.scrollHeight);
		},
		nextStepOne(){
			this.formErrors = false
			
			this.doLiveCheck = true
			this.checkPolis()
			this.checkVin()
			this.checkDate()
			this.checkType()
			if (!this.formErrors) {
				this.step = 2
				// if (this.type == 1) {
				// 	this.framed = 1
				// } else {
				// 	this.framed = 3
				// }
				this.formErrors = false
				this.doLiveCheck = false
				this.errFields = ""
			}
		},
		nextStepTwo(){
			console.log("nextStepTwo")
			this.formErrors = false
			
			this.doLiveCheck = true
            this.checkDrName()
			this.checkDrPassport()
            if (this.driverState == "driver_other") {
                this.checkOtherDrName()
            }
			this.checkDrPhone()
            this.checkDrEmail()
            if (this.driverState == "no_driver") {
                this.moveState = true
            } else {
                this.moveState = false
            }
			if (!this.formErrors) {
				this.framed = ""
				this.step = 3
				this.formErrors = false
				this.doLiveCheck = false
				this.errFields = ""
				
				this.initAddressPlugin()
			}
		},
		initAddressPlugin() {
			let comp = this
			setTimeout(
				function() {
					comp.addressPlugin = $("#place").suggestions({
						token: "60bf50a224066278e1cff6a2799f306222891421",
						type: "ADDRESS",
						count: 5,
						onSelect: function(suggestion) {
							// $(this).attr('title',suggestion.data.kladr_id);
							comp.place = suggestion.value
							comp.kladrId = suggestion.data.kladr_id
						}
					}).suggestions();
					console.log("ss")
				}, 100);
			setTimeout(
				function() {
					comp.addressPlugin = $("#car-view-place").suggestions({
						token: "60bf50a224066278e1cff6a2799f306222891421",
						type: "ADDRESS",
						count: 5,
						onSelect: function(suggestion) {
							// $(this).attr('title',suggestion.data.kladr_id);
							comp.carViewPlace = suggestion.value
							comp.kladrIdViewPlace = suggestion.data.kladr_id
						}
				}).suggestions();
				}, 200);
		},
		nextStepThree(){
			this.formErrors = false
			
			this.doLiveCheck = true
			this.checkPlace()
			this.checkCarCanMove()
			this.checkViewPlace()
			this.checkEvtDescr()
			this.checkCarDescr()
			this.checkFramed()
			if (!this.formErrors) {
				this.step = 4
				this.formErrors = false
				this.doLiveCheck = false
				this.errFields = ""
			}
		},
		nextStepFour(){
			this.formErrors = false
			this.doLiveCheck = true
			this.checkCarPhotos()
			this.checkDamagePhotos()
			this.checkVimPhoto()
			this.checkPanelPhoto()
			if (!this.formErrors) {
				this.step = 5
				this.formErrors = false
				this.doLiveCheck = false
				this.errFields = ""
			}
		},
		nextStepFive(){
			this.formErrors = false
			this.doLiveCheck = true
            this.checkStsPhotos()
            if (!this.moveState){
                this.checkDriverLicPhotos()
            }
			
			if (!this.formErrors) {
				this.step = 6
				this.formErrors = false
				this.doLiveCheck = false
				this.errFields = ""
			}
		},
		nextStepSix() {
			this.step = 7
			this.formErrors = false
			this.doLiveCheck = false
            this.errFields = ""
            window.scrollTo(0,document.body.scrollHeight);
		},
		finNewCase() {
			this.step = 8
			//Sending data to server
			let formData = new FormData();
			formData.append("polis", this.polisCleaned)
			formData.append("vin", this.vin)
			let dateSl = this.date.split("-")
			let date = dateSl[2] + "." + dateSl[1] + "." + dateSl[0]
			formData.append("date", date)
			formData.append("type", this.type)
			formData.append("drName", this.drName)
			formData.append("drPassport", this.drPassport)
			let phone = this.drPhone.replace("+7", "8").replace(/\(/g, '').replace(/\)/g, '').replace(/-/g, '').replace(/_/g, '')
			formData.append("drPhone", phone)
            formData.append("drEmail", this.drEmail)
            formData.append("otherDriverState", this.driverState)
            formData.append("otherDriverName", this.otherDriverName)
            formData.append("noMoveState", this.moveState)
            
			formData.append("place", this.place)
			formData.append("kladrId", this.kladrId)
			let carMoveState = false
			if (this.carCanMove == "true") {
				carMoveState = true
			}
			formData.append("carCanMove", carMoveState)
			formData.append("viewPlace", this.carViewPlace)
			formData.append("viewPlaceKladrId", this.kladrIdViewPlace)
			formData.append("evtDescr", this.evtDescr)
			formData.append("repareWishes", this.repareWishes)
			formData.append("carDescr", this.carDescr)
			formData.append("framed", this.framed)
			formData.append("carPhotosL", this.selectedCarPhotos.length)
			formData.append("damagePhotoL", this.selectedDamagePhotos.length)
			formData.append("stsPhotoL", this.stsPhotos.length)
			formData.append("driverLicPhotoL", this.driverLicPhotos.length)
			formData.append("dtpNotifPhotoL", this.dtpNotifPhotos.length)
			formData.append("govDocPhotoL", this.govDocsPhotos.length)
			formData.append("driverLetterPhotoL", this.driverLetterPhotos.length)
			formData.append("subscription", this.subscrVal)

			let vm = this
			axios.post( '/api/create',
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.requestId = data.data.data
				vm.uploadPhotos()
			})
			.catch(function(response){
				vm.step = 9
				vm.eventNum = ''
			});
			//After receiving data set this.eventNum to received number and set step to 9
		
		},
		checkIfAllPhotosUploaded(){
            console.log(this.uploadedPhotosCount, this.allPhotosCount)
			if (this.uploadedPhotosCount >= 8) {
				this.checkRequestCreated()
			}
		},
		checkRequestCreated() {
			let vm = this
			console.log("Check req created")
			axios.get( '/api/create/check/'+this.requestId)
				.then(function(data){
                    // vm.errLog = data
					if (data.data != "Upload fail") {
                        vm.step = 9
						vm.eventNum = data.data
					} else {
						vm.step = 9
						vm.eventNum = ''
					}
				})
				.catch(function(){
					vm.getStatusRetrs += 1
					if (vm.getStatusRetrs <= 500) {
						vm.checkRequestCreated()
					} else {
                        // vm.errLog = "No more retrs"
						vm.step = 9
						vm.eventNum = ''
						vm.showRetBtn = false
					}
				});
		},
		uploadPhotos() {
			
			this.allPhotosCount = 2 + this.selectedCarPhotos.length + 
							this.selectedDamagePhotos.length +
							this.stsPhotos.length +
							this.driverLicPhotos.length +
							this.dtpNotifPhotos.length +
							this.govDocsPhotos.length +
							this.driverLetterPhotos.length
			this.uploadedPhotosCount = 0
			this.sendVinAndPanelPhotos() 
			this.sendCarPhotos() 
			this.sendDamagePhotos() 
			this.sendStsPhotos() 
			this.sendDriverLicPhotos() 
			this.sendDtpNotifPhotos() 
			this.sendGovDocsPhotos() 
			this.sendDriverLetterPhotos() 
		},
		photosSendRetry() {
			this.photosUploadError = false
			if (this.vinPanelUploadError) {
				this.vinPanelUploadError = false
				this.sendVinAndPanelPhotos() 
			}
			if (this.carPhotosUploadError) {
				this.carPhotosUploadError = false
				this.sendCarPhotos() 
			}
			if (this.damagePhotoUploadError) {
				this.damagePhotoUploadError = false
				this.sendDamagePhotos() 
			}
			if (this.stsPhotoUploadError) {
				this.stsPhotoUploadError = false
				this.sendStsPhotos() 
			}
			if (this.driverLicPhotoUploadError) {
				this.driverLicPhotoUploadError = false
				this.sendDriverLicPhotos() 
			}
			if (this.dtpNotifPhotoUploadError) {
				this.dtpNotifPhotoUploadError = false
				this.sendDtpNotifPhotos() 
			}
			if (this.govDocPhotoUploadError) {
				this.govDocPhotoUploadError = false
				this.sendGovDocsPhotos() 
			}
			if (this.driverLetterPhotoUploadError) {
				this.driverLetterPhotoUploadError = false
				this.sendDriverLetterPhotos() 
			}

		},
		sendVinAndPanelPhotos() {
			let formData = new FormData();
			formData.append("vinPhoto", this.vinPhoto)
			formData.append("panelPhoto", this.panelPhoto)
            let vm = this
            vm.vinPanelUploadError = false
            vm.photosUploadError = false
			axios.post( '/api/create/appendphotos/'+this.requestId + "/vin_panel",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += 2
				vm.panelPhotoUploaded = true
				vm.vinPhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.vinPanelUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendCarPhotos() {
            let vm = this
            vm.carPhotosUploadError = false
            vm.photosUploadError = false
			let formData = new FormData();
			let formData2 = new FormData();
			this.selectedCarPhotos.forEach(function (photo, i) {
				if (i < 4) {
					formData.append("carPhotos_"+(i+1), photo)
				} else {
					formData2.append("carPhotos_"+(i+1), photo)
				}
			})

			axios.post( '/api/create/appendphotos/'+this.requestId + "/carphotos",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += 4
				vm.carPhotosUploadedp1 = true
				if (vm.carPhotosUploadedp2) {
					vm.carPhotosUploaded = true
				}
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.carPhotosUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
			axios.post( '/api/create/appendphotos/'+this.requestId + "/carphotos",
				formData2,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += 4
				vm.carPhotosUploadedp2 = true
				if (vm.carPhotosUploadedp1) {
					vm.carPhotosUploaded = true
				}
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.carPhotosUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendDamagePhotos() {
            let vm = this
            vm.damagePhotoUploadError = false
			let formData = new FormData();
			this.selectedDamagePhotos.forEach(function (photo, i) {
				formData.append("damagePhoto_"+(i+1), photo)
			})
			axios.post( '/api/create/appendphotos/'+this.requestId + "/damagephotos",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += 4
				vm.damagePhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.damagePhotoUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendStsPhotos() {
            let vm = this
            vm.stsPhotoUploadError = false
			let formData = new FormData();
			this.stsPhotos.forEach(function (photo, i) {
				formData.append("stsPhoto_"+(i+1), photo)
			})
			
			axios.post( '/api/create/appendphotos/'+this.requestId + "/stsphotos",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += 2
				vm.stsPhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.stsPhotoUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendDriverLicPhotos() {
			let formData = new FormData();
			this.driverLicPhotos.forEach(function (photo, i) {
				formData.append("driverLicPhoto_"+(i+1), photo)
			})
            let vm = this
            vm.driverLicPhotoUploadError = false
			axios.post( '/api/create/appendphotos/'+this.requestId + "/driverlic",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += 2
				vm.driverLicPhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.driverLicPhotoUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendDtpNotifPhotos() {
			let formData = new FormData();
			var uploadPhotosCount = this.dtpNotifPhotos.length
			if (uploadPhotosCount == 0) {
				this.dtpNotifPhotoUploaded = true
				this.checkIfAllPhotosUploaded()
				return
			}
			this.dtpNotifPhotos.forEach(function (photo, i) {
				formData.append("dtpNotifPhoto_"+(i+1), photo)
			})
            let vm = this
            vm.dtpNotifPhotoUploadError = false
			axios.post( '/api/create/appendphotos/'+this.requestId + "/dtpnotif",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += uploadPhotosCount
				vm.dtpNotifPhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.dtpNotifPhotoUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendGovDocsPhotos(){
			let formData = new FormData();
			var uploadPhotosCount = this.govDocsPhotos.length
			if (uploadPhotosCount == 0) {
				this.govDocPhotoUploaded = true
				this.checkIfAllPhotosUploaded()
				return
			}
			this.govDocsPhotos.forEach(function (photo, i) {
				formData.append("govDocPhoto_"+(i+1), photo)
			})
            let vm = this
            vm.govDocPhotoUploadError = false
			axios.post( '/api/create/appendphotos/'+this.requestId + "/govdocs",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += uploadPhotosCount
				vm.govDocPhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.govDocPhotoUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		sendDriverLetterPhotos(){
			let formData = new FormData();
			var uploadPhotosCount = this.driverLetterPhotos.length
			if (uploadPhotosCount == 0) {
				this.driverLetterPhotoUploaded = true
				this.checkIfAllPhotosUploaded()
				return
			}
			this.driverLetterPhotos.forEach(function (photo, i) {
				formData.append("driverLetterPhoto_"+(i+1), photo)
			})
            let vm = this
            vm.driverLetterPhotoUploadError = false
			axios.post( '/api/create/appendphotos/'+this.requestId + "/driverletter",
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(function(data){
				vm.uploadedPhotosCount += uploadPhotosCount
				vm.driverLetterPhotoUploaded = true
				vm.checkIfAllPhotosUploaded()
			})
			.catch(function(){
				vm.driverLetterPhotoUploadError = true
                vm.photosUploadError = true
                vm.photosSendRetry()
			});
		},
		clean() {
			this.showCancel = false
			this.lastVisitedStep = 0
			this.step = 1
			this.showBtns = true
			this.polis = ""
			this.polisInvalid = false
			this.vin = ""
			this.vinInvalid = false
			this.date = ""
			this.dateInvalid = false
			this.type = ""
			this.typeInvalid = false
			this.formErrors = false
			this.errFields = ""
			this.doLiveCheck = false
			this.drName = ""
			this.drNameInvalid = false
			this.drPassport = ""
			this.drPassportInvalid = false
			this.drPhone = ""
			this.drPhoneInvalid = false
			this.drEmail = ""
			this.drEmailInvalid = false
			this.place = ""
			this.placeInvalid = false
			this.evtDescr = ""
			this.evtDescrInvalid = false
			this.carDescr = ""
			this.carDescrInvalid = false
			this.framed = ""
			this.framedInvalid = false
			this.cameraPhotosShore = []
			this.cameraPhotosTargetName = ""
			this.cameraMaxPhotos = 0
			this.selectedCarPhotos = []
			this.carPhotosInvalid = false
			this.carPhotosLimErr = ""
			this.selectedDamagePhotos = []
			this.damagePhotosInvalid = false
			this.damagePhotosLimErr = ""
			this.vinPhoto = ''
			this.panelPhoto = ''
			this.stsPhotos = []
			this.stsPhotoLimErr = ""
			this.driverLicPhotos = []
			this.driverLicPhotosLimErr = ""
			this.dtpNotifPhotos = []
			this.govDocsPhotos = []
			this.driverLetterPhotos = []
			this.repareWishes = ""
			this.eventNum = 0
			this.getStatusRetrs = 0,
			this.showRetBtn = true,
			//Cleaning files torage
			this.selectedCarPhotosFiles = [],
			this.selectedDamagePhotosFiles = [],
			this.stsPhotosFiles = []
			this.driverLicPhotosFiles = []
			this.dtpNotifPhotosFiles = []
			this.govDocsPhotosFiles = []
			this.driverLetterPhotosFiles = []
			this.subscrVal = ''
		},
		goToMain() {
			document.location.replace('/');
		}
	},
}
function validateEmail(email) {
	if (!email) {
		return false
	}
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function alphanumeric(inputtxt) { 
	if (/^[A-Za-z0-9]+$/.test(inputtxt)) {
		return true;
	} else {
		return false;
	}
}

function resizeImage(imageURL, finishedCB){
    var image = new Image();
	image.onload = function (imageEvent) {

		// Resize the image
		var canvas = document.createElement('canvas'),
			max_size = 1024,
			width = image.width,
			height = image.height;
		if (width > height) {
			if (width > max_size) {
				height *= max_size / width;
				width = max_size;
			}
		} else {
			if (height > max_size) {
				width *= max_size / height;
				height = max_size;
			}
		}
		canvas.width = width;
		canvas.height = height;
		canvas.getContext('2d').drawImage(image, 0, 0, width, height);
		var dataUrl = canvas.toDataURL('image/jpeg');
		finishedCB(dataUrl)
	}
	image.src = imageURL;
};


</script>

<style>


</style>



// WEBPACK FOOTER //
// src/NewRequest.vue